export const getSurplusBeforeTaxYear1 = (value) => {
  return {
    type: "GET_SURPLUS_BEFORE_TAX_YEAR_1",
    payload: value,
  };
};

export const getTemplatePayrollTaxYear1 = (value) => {
  return {
    type: "GET_TEMPLATE_PAYROLL_TAX_YEAR_1",
    payload: value,
  };
};
export const getTemplatePayrollPercentYear1 = (value) => {
  return {
    type: "GET_TEMPLATE_PAYROLL_PERCENT_YEAR_1",
    payload: value,
  };
};
export const getFixedEarnedIncomeYear1 = (value) => {
  return {
    type: "GET_FIXED_EARNED_INCOME_YEAR_1",
    payload: value,
  };
};

export const getStandardTaxReliefYear1 = (value) => {
  return {
    type: "GET_STANDARD_TAX_RELIEF_YEAR_1",
    payload: value,
  };
};
export const getTaxableIncomeYear1 = (value) => {
  return {
    type: "GET_TAXABLE_INCOME_YEAR_1",
    payload: value,
  };
};
export const getLocalTaxesYear1 = (value) => {
  return {
    type: "GET_LOCAL_TAXES_YEAR_1",
    payload: value,
  };
};
export const getLocalTaxesPercentYear1 = (value) => {
  return {
    type: "GET_LOCAL_TAXES_PERCENT_YEAR_1",
    payload: value,
  };
};
export const getStateTaxYear1 = (value) => {
  return {
    type: "GET_STATE_TAX_YEAR_1",
    payload: value,
  };
};
export const getStateTaxCutOfValueYear1 = (value) => {
  return {
    type: "GET_STATE_TAX_CUT_OF_VALUE_YEAR_1",
    payload: value,
  };
};
export const getStateTaxPercentYear1 = (value) => {
  return {
    type: "GET_STATE_TAX_PERCENT_YEAR_1",
    payload: value,
  };
};
export const getPayrollTaxYear1 = (value) => {
  return {
    type: "GET_PAYROLL_TAX_YEAR_1",
    payload: value,
  };
};
export const getPayrollTaxPercentYear1 = (value) => {
  return {
    type: "GET_PAYROLL_TAX_PERCENT_YEAR_1",
    payload: value,
  };
};
export const getGeneralPensionYear1 = (value) => {
  return {
    type: "GET_GENERAL_PENSION_YEAR_1",
    payload: value,
  };
};
export const getGeneralPensionCutOffValueYear1 = (value) => {
  return {
    type: "GET_GENERAL_PENSION_CUT_OFF_VALUE_YEAR_1",
    payload: value,
  };
};
export const getGeneralPensionPercentYear1 = (value) => {
  return {
    type: "GET_GENERAL_PENSION_PERCENT_YEAR_1",
    payload: value,
  };
};
export const getFuneralFeesYear1 = (value) => {
  return {
    type: "GET_FUNERAL_FEES_YEAR_1",
    payload: value,
  };
};
export const getFuneralFeesPercentYear1 = (value) => {
  return {
    type: "GET_FUNERAL_FEES_PERCENT_YEAR_1",
    payload: value,
  };
};
export const getReductionOfGeneralPensionYear1 = (value) => {
  return {
    type: "GET_REDUCTION_OF_GENERAL_PENSION_YEAR_1",
    payload: value,
  };
};
export const getEarnedIncomeTaxYear1 = (value) => {
  return {
    type: "GET_EARNED_INCOME_TAX_YEAR_1",
    payload: value,
  };
};
export const getEarnedIncomeTaxCutOffValueYear1 = (value) => {
  return {
    type: "GET_EARNED_INCOME_TAX_CUT_OFF_VALUE_YEAR_1",
    payload: value,
  };
};
export const getEarnedIncomeTaxPercentYear1 = (value) => {
  return {
    type: "GET_EARNED_INCOME_TAX_PERCENT_YEAR_1",
    payload: value,
  };
};
export const getNetProfitPerYearYear1 = (value) => {
  return {
    type: "GET_NET_PROFIT_PER_YEAR_YEAR_1",
    payload: value,
  };
};
export const getNetProfitPerMonthYear1 = (value) => {
  return {
    type: "GET_NET_PROFIT_PER_MONTH_YEAR_1",
    payload: value,
  };
};
export const getGeneralPayrollTaxYear1 = (value) => {
  return {
    type: "GET_GENERAL_PAYROLL_TAX_YEAR_1",
    payload: value,
  };
};
export const getGeneralPayrollTaxPercentYear1 = (value) => {
  return {
    type: "GET_GENERAL_PAYROLL_TAX_PERCENT_YEAR_1",
    payload: value,
  };
};
export const getGrossAnnualSalaryYear1 = (value) => {
  return {
    type: "GET_GROSS_ANNUAL_SALARY_YEAR_1",
    payload: value,
  };
};
export const getNonTaxableIncomeLimitYear1 = (value) => {
  return {
    type: "GET_NON_TAXABLE_INCOME_LIMIT_YEAR_1",
    payload: value,
  };
};
